const Order = ({ size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <path d="M6 14.5L12 20.5L18 14.5" fillRule="evenodd" fill="currentColor" className="sorting--desc" />
      <path d="M18 9.5L12 3.5L6 9.5" fillRule="evenodd" fill="currentColor" className="sorting--asc" />
    </svg>
  );
};

export default Order;
